export default {
	Reseller: '*',
	EndUser: ['users'],
}